module.exports = __webpack_public_path__ + "img/lightbulb-green.f28ad8ac.png";